import { Component, Injectable, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { PermissionService } from "../services/permission.service";
import { RoutePaths } from "../shared/constants/routePaths.constants";

@Component({
  standalone: false, changeDetection: ChangeDetectionStrategy.Eager,
 template: "" })
export class PermissionRedirectPlaceholderComponent {}

export interface EntityRouteData {
    objectId?: string;
}

/**
 * Guard for parent routes with multiple guarded children.
 * Auto-discovers sibling child routes from the Angular route config —
 * no need to duplicate path/objectId in route data.
 * Redirects to the first child the user has read access to,
 * or to the unauthorized page if none are accessible.
 */
@Injectable({ providedIn: "root" })
export class PermissionRedirectGuard {
    constructor(
        private permissionService: PermissionService,
        private router: Router,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const siblings = route.parent?.routeConfig?.children ?? [];
        const basePath =
            "/" +
            route.pathFromRoot
                .map((r) => r.url.map((u) => u.path).join("/"))
                .filter((s) => s.length > 0)
                .join("/");

        const first = siblings.find((child) => {
            if (!child.path || child.redirectTo) return false;
            const objectId = (child.data as EntityRouteData)?.objectId;
            return (
                !objectId || this.permissionService.hasReadPermission(objectId)
            );
        });

        if (first) {
            this.router.navigateByUrl(`${basePath}/${first.path}`);
        } else {
            this.router.navigate([RoutePaths.unauthorized]);
        }
        return false;
    }
}
